import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquareWarning } from "lucide-react";
import api, { apiError } from "../lib/api";
import { useFlash } from "../lib/flash";
import { kr } from "./SmsSettings";

export default function SmsQuotaBanner({ q, onChange }) {
  const flash = useFlash();
  const [busy, setBusy] = useState(false);
  if (!q || !q.alert || q.billing_exempt || ["off", "trial", "locked"].includes(q.reason)) return null;
  const full = q.alert === "100";
  const paused = full && !q.extra_on;
  const enable = async () => {
    setBusy(true);
    try {
      const r = await api.put("/settings", { sms_extra: true });
      flash(r.data.flash);
      onChange?.();
    } catch (err) {
      flash(apiError(err.response?.data?.detail) || err.message, "error");
    } finally {
      setBusy(false);
    }
  };
  let title, text;
  if (paused) {
    title = `SMS er sat på pause – alle ${q.limit} SMS i ${q.month} er brugt.`;
    text = `Kunderne får stadig besked på Messenger. Slå ekstra SMS til for ${kr(q.extra_price_ore)} ekskl. moms pr. SMS – det lægges på næste faktura.`;
  } else if (full) {
    title = q.reason === "quota" ? `Loftet for ekstra SMS i ${q.month} er nået.` : `Alle ${q.limit} inkluderede SMS i ${q.month} er brugt – ekstra SMS er i brug.`;
    text = `${q.extra_used} ekstra SMS indtil nu (${kr(q.extra_cost_ore)} ekskl. moms på næste faktura).`;
  } else {
    title = `Du har brugt ${q.used} af ${q.limit} SMS i ${q.month}.`;
    text = q.extra_on ? "Herefter sendes ekstra SMS, som du har slået til." : "Når de er brugt, stopper SMS'erne resten af måneden, medmindre du slår ekstra SMS til.";
  }
  return (
    <section className={"sms-alert" + (paused ? " paused" : "")} role="status" data-testid="sms-quota-banner" data-level={q.alert}>
      <span className="fa-icon" aria-hidden="true"><MessageSquareWarning size={20} /></span>
      <div className="fa-text">
        <b data-testid="sms-quota-banner-title">{title}</b>
        <span>{text}</span>
      </div>
      {paused ? (
        <button className="btn primary fa-btn" onClick={enable} disabled={busy} data-testid="sms-quota-enable-extra">
          {busy ? "Slår til…" : "Slå ekstra SMS til"}
        </button>
      ) : (
        <Link className="btn fa-btn" to="/settings" data-testid="sms-quota-settings-link">Se SMS-forbrug</Link>
      )}
    </section>
  );
}
